import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
  FormGroup,
} from "reactstrap";
import Swal from "sweetalert2";

import { MRISUserApproval } from "../store/MaterialRequest/actions";
import { PIitemCancel } from "../store/RequetForQuotation/actions";

// import { PIDetailsModel_close } from "../../store/RequetForQuotation/actions";
class CancleItemModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rejectErrorMsg: "",
      rejectItemText: "",
    };
  }

  CloseModel() {
    if (this.props.modelClose) {
      this.props.modelClose();
      this.setState({ rejectErrorMsg: "", rejectItemText: "" });
    }
  }
  componentDidMount() {
    this.setState({ rejectErrorMsg: "", rejectItemText: "" });
  }
  MRitemCancelledRequest = (item, mrstatus) => {
    var data = {
      mrstatus: mrstatus,
      materialrequest_id: item.materialrequest_id,
      mritem_id: item.id,
      t_product_id: item.product.id,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
      t_make: item.t_make == null ? item.make : item.t_make,
      t_description:
        item.t_description == null ? item.description : item.t_description,
      description: this.state.rejectItemText,
    };
    if (mrstatus === 13) {
      if (data.description !== "") {
        Swal.fire({
          title: "Are you sure cancel this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.props.MRISUserApproval(data);
            this.CloseModel();
          }
        });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };
  PIitemCancelledRequest = (item, pistatus) => {
    // var piimris = item.piimris.map((p) => {
    //   p.mritem_id = p.mritem.id;
    //   p.unit_id = p.unit.id;

    //   return p;
    // });
    var data = {
      pistatus: pistatus,
      purchaseindent_id: item.purchaseindent_id,
      piitem_id: item.id,
      t_product_id: item.product.id,
      t_make: item.make,
      t_description: item.description,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit,
      // piimris: piimris,
      description: this.state.rejectItemText,
    };
    if (pistatus === 10) {
      if (data.description !== "") {
        Swal.fire({
          title: "Are you sure cancel this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.props.PIitemCancel(data);
            this.CloseModel();
          }
        });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.modelOpen}
          toggle={() => {
            this.CloseModel();
          }}
          backdrop="static"
          centered
          // size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.CloseModel();
            }}
          >
            Cancle Item
          </ModalHeader>
          <ModalBody className="pt-0">
            <Input
              className="mb-0 form-control "
              type="textarea"
              step="1"
              name="reject"
              id="reject_item"
              value={this.state.rejectItemText}
              onChange={(e) =>
                this.setState({ rejectItemText: e.target.value })
              }
              placeholder="why are you cancelled the item"
            />
            {this.state.rejectErrorMsg !== "" && (
              <span className="text-danger mt-0">
                {this.state.rejectErrorMsg}
              </span>
            )}
            <div className="float-right mt-2">
              <FormGroup>
                <Button
                  type="button"
                  color="light "
                  className="waves-effect waves-light d-inline-block mr-2"
                  onClick={() => this.CloseModel()}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  color="primary"
                  className="waves-effect waves-light d-inline-block"
                  onClick={() => {
                    this.props.ItemCancelLevel === "MRItemCancle"
                      ? this.MRitemCancelledRequest(this.props.item, 13)
                      : this.PIitemCancelledRequest(this.props.item, 10);
                  }}
                >
                  Submit
                </Button>
              </FormGroup>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { PIDetailsModel, PIRowDetails, loading } = state.RequestForQuotation;

  return {
    PIDetailsModel,
    PIRowDetails,
    loading,
  };
};

export default connect(mapStatetoProps, {
  MRISUserApproval,
  PIitemCancel,
})(CancleItemModel);
